// Redacted Remilio Babies NFT data
export const remilioBabiesNFTs = [
  {
    id: 9992,
    name: 'Redacted Remilio Baby #9992',
    image: 'https://remilio.org/remilio/9992.png',
    price: '1.04'
  },
  {
    id: 9982,
    name: 'Redacted Remilio Baby #9982',
    image: 'https://remilio.org/remilio/9982.png',
    price: '1.04'
  },
  {
    id: 9993,
    name: 'Redacted Remilio Baby #9993',
    image: 'https://remilio.org/remilio/9993.png',
    price: '1.04'
  },
  {
    id: 9983,
    name: 'Redacted Remilio Baby #9983',
    image: 'https://remilio.org/remilio/9983.png',
    price: '1.04'
  },
    
      {
    id: 9991,
    name: 'Redacted Remilio Baby #9991',
    image: 'https://remilio.org/remilio/9991.png',
    price: '1.04'
  },
  {
    id: 9994,
    name: 'Redacted Remilio Baby #9994',
    image: 'https://remilio.org/remilio/9994.png',
    price: '1.04'
  },
  {
    id: 9985,
    name: 'Redacted Remilio Baby #9985',
    image: 'https://remilio.org/remilio/9985.png',
    price: '1.04'
  },
  {
    id: 9986,
    name: 'Redacted Remilio Baby #9986',
    image: 'https://remilio.org/remilio/9986.png',
    price: '1.04'
  },
  {
    id: 9995,
    name: 'Redacted Remilio Baby #9995',
    image: 'https://remilio.org/remilio/9995.png',
    price: '1.04'
  },
  {
    id: 9989,
    name: 'Redacted Remilio Baby #9989',
    image: 'https://remilio.org/remilio/9989.png',
    price: '1.04'
  },
  {
    id: 9987,
    name: 'Redacted Remilio Baby #9987',
    image: 'https://remilio.org/remilio/9987.png',
    price: '1.04'
  },
  {
    id: 9997,
    name: 'Redacted Remilio Baby #9997',
    image: 'https://remilio.org/remilio/9997.png',
    price: '1.04'
  },
  {
    id: 9999,
    name: 'Redacted Remilio Baby #9999',
    image: 'https://remilio.org/remilio/9999.png',
    price: '1.04'
  },
  {
    id: 9988,
    name: 'Redacted Remilio Baby #9988',
    image: 'https://remilio.org/remilio/9988.png',
    price: '1.04'
  },
  {
    id: 9996,
    name: 'Redacted Remilio Baby #9996',
    image: 'https://remilio.org/remilio/9996.png',
    price: '1.04'
  },
  {
    id: 10000,
    name: 'Redacted Remilio Baby #10000',
    image: 'https://remilio.org/remilio/10000.png',
    price: '1.04'
  },
  {
    id: 9990,
    name: 'Redacted Remilio Baby #9990',
    image: 'https://remilio.org/remilio/9990.png',
    price: '1.04'
  },
  {
    id: 9998,
    name: 'Redacted Remilio Baby #9998',
    image: 'https://remilio.org/remilio/9998.png',
    price: '1.04'
  },
  {
    id: 9984,
    name: 'Redacted Remilio Baby #9984',
    image: 'https://remilio.org/remilio/9984.png',
    price: '1.04'
  },
  {
    id: 9945,
    name: 'Redacted Remilio Baby #9945',
    image: 'https://remilio.org/remilio/9945.png',
    price: '1.04'
  },
  {
    id: 9934,
    name: 'Redacted Remilio Baby #9934',
    image: 'https://remilio.org/remilio/9934.png',
    price: '1.04'
  },
  {
    id: 9929,
    name: 'Redacted Remilio Baby #9929',
    image: 'https://remilio.org/remilio/9929.png',
    price: '1.04'
  },
  {
    id: 9926,
    name: 'Redacted Remilio Baby #9926',
    image: 'https://remilio.org/remilio/9926.png',
    price: '1.04'
  },
  {
    id: 9937,
    name: 'Redacted Remilio Baby #9937',
    image: 'https://remilio.org/remilio/9937.png',
    price: '1.04'
  },
  {
    id: 9930,
    name: 'Redacted Remilio Baby #9930',
    image: 'https://remilio.org/remilio/9930.png',
    price: '1.04'
  },
  {
    id: 9923,
    name: 'Redacted Remilio Baby #9923',
    image: 'https://remilio.org/remilio/9923.png',
    price: '1.04'
  },
  {
    id: 9917,
    name: 'Redacted Remilio Baby #9917',
    image: 'https://remilio.org/remilio/9917.png',
    price: '1.04'
  },
  {
    id: 9938,
    name: 'Redacted Remilio Baby #9938',
    image: 'https://remilio.org/remilio/9938.png',
    price: '1.04'
  },
  {
    id: 9925,
    name: 'Redacted Remilio Baby #9925',
    image: 'https://remilio.org/remilio/9925.png',
    price: '1.04'
  },
  {
    id: 9939,
    name: 'Redacted Remilio Baby #9939',
    image: 'https://remilio.org/remilio/9939.png',
    price: '1.04'
  },
  {
    id: 9932,
    name: 'Redacted Remilio Baby #9932',
    image: 'https://remilio.org/remilio/9932.png',
    price: '1.04'
  },
  {
    id: 9920,
    name: 'Redacted Remilio Baby #9920',
    image: 'https://remilio.org/remilio/9920.png',
    price: '1.04'
  },
  {
    id: 9933,
    name: 'Redacted Remilio Baby #9933',
    image: 'https://remilio.org/remilio/9933.png',
    price: '1.04'
  },
  {
    id: 9927,
    name: 'Redacted Remilio Baby #9927',
    image: 'https://remilio.org/remilio/9927.png',
    price: '1.04'
  },
  {
    id: 9928,
    name: 'Redacted Remilio Baby #9928',
    image: 'https://remilio.org/remilio/9928.png',
    price: '1.04'
  },
  {
    id: 9922,
    name: 'Redacted Remilio Baby #9922',
    image: 'https://remilio.org/remilio/9922.png',
    price: '1.04'
  },
  {
    id: 9924,
    name: 'Redacted Remilio Baby #9924',
    image: 'https://remilio.org/remilio/9924.png',
    price: '1.04'
  },
  {
    id: 9931,
    name: 'Redacted Remilio Baby #9931',
    image: 'https://remilio.org/remilio/9931.png',
    price: '1.04'
  },
  {
    id: 9918,
    name: 'Redacted Remilio Baby #9918',
    image: 'https://remilio.org/remilio/9918.png',
    price: '1.04'
  },
  {
    id: 9921,
    name: 'Redacted Remilio Baby #9921',
    image: 'https://remilio.org/remilio/9921.png',
    price: '1.04'
  },
  {
    id: 9919,
    name: 'Redacted Remilio Baby #9919',
    image: 'https://remilio.org/remilio/9919.png',
    price: '1.04'
  },
  {
    id: 9916,
    name: 'Redacted Remilio Baby #9916',
    image: 'https://remilio.org/remilio/9916.png',
    price: '1.04'
  },
  {
    id: 9892,
    name: 'Redacted Remilio Baby #9892',
    image: 'https://remilio.org/remilio/9892.png',
    price: '1.04'
  },
  {
    id: 9887,
    name: 'Redacted Remilio Baby #9887',
    image: 'https://remilio.org/remilio/9887.png',
    price: '1.04'
  },
  {
    id: 9893,
    name: 'Redacted Remilio Baby #9893',
    image: 'https://remilio.org/remilio/9893.png',
    price: '1.04'
  },
  {
    id: 9891,
    name: 'Redacted Remilio Baby #9891',
    image: 'https://remilio.org/remilio/9891.png',
    price: '1.04'
  },
  {
    id: 9890,
    name: 'Redacted Remilio Baby #9890',
    image: 'https://remilio.org/remilio/9890.png',
    price: '1.04'
  },
  {
    id: 9885,
    name: 'Redacted Remilio Baby #9885',
    image: 'https://remilio.org/remilio/9885.png',
    price: '1.04'
  },
  {
    id: 9888,
    name: 'Redacted Remilio Baby #9888',
    image: 'https://remilio.org/remilio/9888.png',
    price: '1.04'
  },
  {
    id: 9884,
    name: 'Redacted Remilio Baby #9884',
    image: 'https://remilio.org/remilio/9884.png',
    price: '1.04'
  },
  {
    id: 9883,
    name: 'Redacted Remilio Baby #9883',
    image: 'https://remilio.org/remilio/9883.png',
    price: '1.04'
  },
  {
    id: 9886,
    name: 'Redacted Remilio Baby #9886',
    image: 'https://remilio.org/remilio/9886.png',
    price: '1.04'
  },
  {
    id: 9881,
    name: 'Redacted Remilio Baby #9881',
    image: 'https://remilio.org/remilio/9881.png',
    price: '1.04'
  },
  {
    id: 9882,
    name: 'Redacted Remilio Baby #9882',
    image: 'https://remilio.org/remilio/9882.png',
    price: '1.04'
  },
  {
    id: 9880,
    name: 'Redacted Remilio Baby #9880',
    image: 'https://remilio.org/remilio/9880.png',
    price: '1.04'
  },
  {
    id: 9879,
    name: 'Redacted Remilio Baby #9879',
    image: 'https://remilio.org/remilio/9879.png',
    price: '1.04'
  },
  {
    id: 9873,
    name: 'Redacted Remilio Baby #9873',
    image: 'https://remilio.org/remilio/9873.png',
    price: '1.04'
  },
  {
    id: 9870,
    name: 'Redacted Remilio Baby #9870',
    image: 'https://remilio.org/remilio/9870.png',
    price: '1.04'
  },
  {
    id: 9877,
    name: 'Redacted Remilio Baby #9877',
    image: 'https://remilio.org/remilio/9877.png',
    price: '1.04'
  },
  {
    id: 9876,
    name: 'Redacted Remilio Baby #9876',
    image: 'https://remilio.org/remilio/9876.png',
    price: '1.04'
  },
  {
    id: 9871,
    name: 'Redacted Remilio Baby #9871',
    image: 'https://remilio.org/remilio/9871.png',
    price: '1.04'
  },
  {
    id: 9869,
    name: 'Redacted Remilio Baby #9869',
    image: 'https://remilio.org/remilio/9869.png',
    price: '1.04'
  },
  {
    id: 9868,
    name: 'Redacted Remilio Baby #9868',
    image: 'https://remilio.org/remilio/9868.png',
    price: '1.04'
  },
  {
    id: 9872,
    name: 'Redacted Remilio Baby #9872',
    image: 'https://remilio.org/remilio/9872.png',
    price: '1.04'
  },
  {
    id: 9867,
    name: 'Redacted Remilio Baby #9867',
    image: 'https://remilio.org/remilio/9867.png',
    price: '1.04'
  },
  {
    id: 9863,
    name: 'Redacted Remilio Baby #9863',
    image: 'https://remilio.org/remilio/9863.png',
    price: '1.04'
  },
  {
    id: 9866,
    name: 'Redacted Remilio Baby #9866',
    image: 'https://remilio.org/remilio/9866.png',
    price: '1.04'
  },
  {
    id: 9862,
    name: 'Redacted Remilio Baby #9862',
    image: 'https://remilio.org/remilio/9862.png',
    price: '1.04'
  },
  {
    id: 9857,
    name: 'Redacted Remilio Baby #9857',
    image: 'https://remilio.org/remilio/9857.png',
    price: '1.04'
  },
  {
    id: 9865,
    name: 'Redacted Remilio Baby #9865',
    image: 'https://remilio.org/remilio/9865.png',
    price: '1.04'
  },
  {
    id: 9864,
    name: 'Redacted Remilio Baby #9864',
    image: 'https://remilio.org/remilio/9864.png',
    price: '1.04'
  },
  {
    id: 9861,
    name: 'Redacted Remilio Baby #9861',
    image: 'https://remilio.org/remilio/9861.png',
    price: '1.04'
  },
  {
    id: 9859,
    name: 'Redacted Remilio Baby #9859',
    image: 'https://remilio.org/remilio/9859.png',
    price: '1.04'
  },
  {
    id: 9853,
    name: 'Redacted Remilio Baby #9853',
    image: 'https://remilio.org/remilio/9853.png',
    price: '1.04'
  },
  {
    id: 9860,
    name: 'Redacted Remilio Baby #9860',
    image: 'https://remilio.org/remilio/9860.png',
    price: '1.04'
  },
  {
    id: 9858,
    name: 'Redacted Remilio Baby #9858',
    image: 'https://remilio.org/remilio/9858.png',
    price: '1.04'
  },
  {
    id: 9848,
    name: 'Redacted Remilio Baby #9848',
    image: 'https://remilio.org/remilio/9848.png',
    price: '1.04'
  },
  {
    id: 9855,
    name: 'Redacted Remilio Baby #9855',
    image: 'https://remilio.org/remilio/9855.png',
    price: '1.04'
  },
  {
    id: 9856,
    name: 'Redacted Remilio Baby #9856',
    image: 'https://remilio.org/remilio/9856.png',
    price: '1.04'
  },
  {
    id: 9854,
    name: 'Redacted Remilio Baby #9854',
    image: 'https://remilio.org/remilio/9854.png',
    price: '1.04'
  },
  {
    id: 9852,
    name: 'Redacted Remilio Baby #9852',
    image: 'https://remilio.org/remilio/9852.png',
    price: '1.04'
  },
  {
    id: 9849,
    name: 'Redacted Remilio Baby #9849',
    image: 'https://remilio.org/remilio/9849.png',
    price: '1.04'
  },
  {
    id: 9843,
    name: 'Redacted Remilio Baby #9843',
    image: 'https://remilio.org/remilio/9843.png',
    price: '1.04'
  },
  {
    id: 9845,
    name: 'Redacted Remilio Baby #9845',
    image: 'https://remilio.org/remilio/9845.png',
    price: '1.04'
  },
  {
    id: 9851,
    name: 'Redacted Remilio Baby #9851',
    image: 'https://remilio.org/remilio/9851.png',
    price: '1.04'
  },
  {
    id: 9842,
    name: 'Redacted Remilio Baby #9842',
    image: 'https://remilio.org/remilio/9842.png',
    price: '1.04'
  },
  {
    id: 9839,
    name: 'Redacted Remilio Baby #9839',
    image: 'https://remilio.org/remilio/9839.png',
    price: '1.04'
  },
  {
    id: 9838,
    name: 'Redacted Remilio Baby #9838',
    image: 'https://remilio.org/remilio/9838.png',
    price: '1.04'
  },
  {
    id: 9850,
    name: 'Redacted Remilio Baby #9850',
    image: 'https://remilio.org/remilio/9850.png',
    price: '1.04'
  },
  {
    id: 9844,
    name: 'Redacted Remilio Baby #9844',
    image: 'https://remilio.org/remilio/9844.png',
    price: '1.04'
  },
  {
    id: 9847,
    name: 'Redacted Remilio Baby #9847',
    image: 'https://remilio.org/remilio/9847.png',
    price: '1.04'
  },
  {
    id: 9846,
    name: 'Redacted Remilio Baby #9846',
    image: 'https://remilio.org/remilio/9846.png',
    price: '1.04'
  },
  {
    id: 9836,
    name: 'Redacted Remilio Baby #9836',
    image: 'https://remilio.org/remilio/9836.png',
    price: '1.04'
  },
  {
    id: 9826,
    name: 'Redacted Remilio Baby #9826',
    image: 'https://remilio.org/remilio/9826.png',
    price: '1.04'
  },
  {
    id: 9828,
    name: 'Redacted Remilio Baby #9828',
    image: 'https://remilio.org/remilio/9828.png',
    price: '1.04'
  },
  {
    id: 9831,
    name: 'Redacted Remilio Baby #9831',
    image: 'https://remilio.org/remilio/9831.png',
    price: '1.04'
  },
  {
    id: 9825,
    name: 'Redacted Remilio Baby #9825',
    image: 'https://remilio.org/remilio/9825.png',
    price: '1.04'
  },
  {
    id: 9827,
    name: 'Redacted Remilio Baby #9827',
    image: 'https://remilio.org/remilio/9827.png',
    price: '1.04'
  },
  {
    id: 9823,
    name: 'Redacted Remilio Baby #9823',
    image: 'https://remilio.org/remilio/9823.png',
    price: '1.04'
  },
  {
    id: 9830,
    name: 'Redacted Remilio Baby #9830',
    image: 'https://remilio.org/remilio/9830.png',
    price: '1.04'
  }
];
